import { isMorfiMarketsEmail } from '@/config/operator-dashboard';
import type { Network } from '@/lib/network/types';

export function fundingLocationOverrideEnabled(
  email: string | null | undefined,
  network: Network,
  preference: boolean = true,
): boolean {
  return isMorfiMarketsEmail(email) && network !== 'mainnet' && preference;
}
